export const translations = {
    en: {
        app_name: "Biopotions",
        home: "Home",
        favorites: "Favorites",
        about: "About",
        search_placeholder: "Search for a body part or ailment...",
        hero_title_prefix: "Natural Remedies for",
        hero_title_highlight: "Everyday Ailments",
        hero_subtitle: "Find gentle, effective home remedies curated for your well-being.",
        footer_text: "Biopotions. Natural remedies for a better life.",
        footer_disclaimer: "Disclaimer: This information is for educational purposes only. Consult a doctor for medical advice.",
        body_part_not_found: "Body part not found",
        back_to_home: "Back to Home",
        select_ailment: "Select an ailment to view natural remedies.",
        ailment_not_found: "Ailment not found",
        back: "Back",
        remedies_for: "Natural remedies recommended for this condition.",
        why_it_works: "Why it works",
        preparation: "Preparation",
        note: "Note",
        saved_remedies: "Your Saved Remedies",
        no_saved_remedies: "You haven't saved any remedies yet.",
        explore_remedies: "Explore Remedies",
        view_details: "View Details",
        remove_favorite: "Remove from favorites",
        for: "For",
        top_ingredients: "Top Ingredients",
        versatility_score: "Versatility Score",
        safety_rating: "Safety Rating",
        common_uses: "Common Uses",
        filter_by_category: "Filter by Category",
        sort_by: "Sort by",
        all_categories: "All Categories",
        name_asc: "Name (A-Z)",
        versatility_desc: "Versatility (High-Low)",
        safety_asc: "Safety (1-5)",
        // Categories
        cat_food: "Food",
        cat_herb: "Herb",
        cat_spice: "Spice",
        cat_liquid: "Liquid",
        cat_oil: "Oil",
        cat_fruit: "Fruit",
        cat_seed: "Seed",
        // Support
        supportTitle: "Support BioPotions",
        supportText: "BioPotions is a free resource. If you find it helpful, please consider supporting our work to keep the server running and the content fresh.",
        paypal: "Donate with PayPal",
        coffee: "Buy me a Coffee",
        thanks: "Thank you for your support! ❤️",
        // Search Types
        type_body_part: "Body Part",
        type_ailment: "Ailment",
        type_ingredient: "Ingredient",
        // Footer New
        footer_desc: "Natural remedies for a better life. Discover the power of nature.",
        quick_links: "Quick Links",
        legal: "Legal",
        privacy_policy: "Privacy Policy",
        terms_service: "Terms of Service",
        connect: "Connect",
        portfolio: "Portfolio",
        contact_us: "Contact Us",
        // Ingredient Details
        ingredient_not_found: "Ingredient Not Found",
        safety_label: "Safety",
        key_properties: "Key Properties",
        recommended_dosage: "Recommended Dosage",
        sources_references: "Sources & References",
        ref_link: "Ref"
    },
    es: {
        app_name: "Biopotions",
        home: "Inicio",
        favorites: "Favoritos",
        about: "Acerca de",
        search_placeholder: "Busca una parte del cuerpo o dolencia...",
        hero_title_prefix: "Remedios Naturales para",
        hero_title_highlight: "Dolencias Comunes",
        hero_subtitle: "Encuentra remedios caseros suaves y efectivos seleccionados para tu bienestar.",
        footer_text: "Biopociones. Remedios naturales para una vida mejor.",
        footer_disclaimer: "Aviso: Esta información es solo para fines educativos. Consulte a un médico para obtener asesoramiento.",
        body_part_not_found: "Parte del cuerpo no encontrada",
        back_to_home: "Volver al Inicio",
        select_ailment: "Selecciona una dolencia para ver remedios naturales.",
        ailment_not_found: "Dolencia no encontrada",
        back: "Volver",
        remedies_for: "Remedios naturales recomendados para esta condición.",
        why_it_works: "Por qué funciona",
        preparation: "Preparación",
        note: "Nota",
        saved_remedies: "Tus Remedios Guardados",
        no_saved_remedies: "Aún no has guardado ningún remedio.",
        explore_remedies: "Explorar Remedios",
        view_details: "Ver Detalles",
        remove_favorite: "Eliminar de favoritos",
        for: "Para",
        top_ingredients: "Top Ingredientes",
        versatility_score: "Puntaje de Versatilidad",
        safety_rating: "Calificación de Seguridad",
        common_uses: "Usos Comunes",
        filter_by_category: "Filtrar por Categoría",
        sort_by: "Ordenar por",
        all_categories: "Todas las Categorías",
        name_asc: "Nombre (A-Z)",
        versatility_desc: "Versatilidad (Alto-Bajo)",
        safety_asc: "Seguridad (1-5)",
        // Categories
        cat_food: "Alimento",
        cat_herb: "Hierba",
        cat_spice: "Especia",
        cat_liquid: "Líquido",
        cat_oil: "Aceite",
        cat_fruit: "Fruta",
        cat_seed: "Semilla",
        // Support
        supportTitle: "Apoya a BioPotions",
        supportText: "BioPotions es un recurso gratuito. Si te resulta útil, considera apoyar nuestro trabajo para mantener el servidor funcionando y el contenido fresco.",
        paypal: "Donar con PayPal",
        coffee: "Cómprame un Café",
        thanks: "¡Gracias por tu apoyo! ❤️",
        // Search Types
        type_body_part: "Parte del Cuerpo",
        type_ailment: "Dolencia",
        type_ingredient: "Ingrediente",
        // Footer New
        footer_desc: "Remedios naturales para una vida mejor. Descubre el poder de la naturaleza.",
        quick_links: "Enlaces Rápidos",
        legal: "Legal",
        privacy_policy: "Política de Privacidad",
        terms_service: "Términos de Servicio",
        connect: "Conectar",
        portfolio: "Portafolio",
        contact_us: "Contáctanos",
        // Ingredient Details
        ingredient_not_found: "Ingrediente no encontrado",
        safety_label: "Seguridad",
        key_properties: "Propiedades Clave",
        recommended_dosage: "Dosis Recomendada",
        sources_references: "Fuentes y Referencias",
        ref_link: "Ref"
    },
    fr: {
        app_name: "Biopotions",
        home: "Accueil",
        favorites: "Favoris",
        about: "À propos",
        search_placeholder: "Rechercher une partie du corps ou une affection...",
        hero_title_prefix: "Remèdes Naturels pour",
        hero_title_highlight: "Maux Quotidiens",
        hero_subtitle: "Trouvez des remèdes maison doux et efficaces sélectionnés pour votre bien-être.",
        footer_text: "Biopotions. Des remèdes naturels pour une vie meilleure.",
        footer_disclaimer: "Avis : Ces informations sont à des fins éducatives uniquement. Consultez un médecin pour un avis médical.",
        body_part_not_found: "Partie du corps introuvable",
        back_to_home: "Retour à l'accueil",
        select_ailment: "Sélectionnez une affection pour voir les remèdes naturels.",
        ailment_not_found: "Affection introuvable",
        back: "Retour",
        remedies_for: "Remèdes naturels recommandés pour cette condition.",
        why_it_works: "Pourquoi ça marche",
        preparation: "Préparation",
        note: "Remarque",
        saved_remedies: "Vos Remèdes Enregistrés",
        no_saved_remedies: "Vous n'avez pas encore enregistré de remèdes.",
        explore_remedies: "Explorer les Remèdes",
        view_details: "Voir les Détails",
        remove_favorite: "Retirer des favoris",
        for: "Pour",
        top_ingredients: "Top Ingrédients",
        versatility_score: "Score de Polyvalence",
        safety_rating: "Note de Sécurité",
        common_uses: "Usages Courants",
        filter_by_category: "Filtrer par Catégorie",
        sort_by: "Trier par",
        all_categories: "Toutes Catégories",
        name_asc: "Nom (A-Z)",
        versatility_desc: "Polyvalence (Haut-Bas)",
        safety_asc: "Sécurité (1-5)",
        // Categories
        cat_food: "Nourriture",
        cat_herb: "Herbe",
        cat_spice: "Épice",
        cat_liquid: "Liquide",
        cat_oil: "Huile",
        cat_fruit: "Fruit",
        cat_seed: "Graine",
        // Support
        supportTitle: "Soutenez BioPotions",
        supportText: "BioPotions est une ressource gratuite. Si vous la trouvez utile, envisagez de soutenir notre travail pour maintenir le serveur en marche et le contenu à jour.",
        paypal: "Faire un don PayPal",
        coffee: "Offrez-moi un Café",
        thanks: "Merci pour votre soutien ! ❤️",
        // Search Types
        type_body_part: "Partie du Corps",
        type_ailment: "Affection",
        type_ingredient: "Ingrédient",
        // Footer New
        footer_desc: "Des remèdes naturels pour une vie meilleure. Découvrez le pouvoir de la nature.",
        quick_links: "Liens Rapides",
        legal: "Légal",
        privacy_policy: "Politique de Confidentialité",
        terms_service: "Conditions d'Utilisation",
        connect: "Connecter",
        portfolio: "Portfolio",
        contact_us: "Contactez-nous",
        // Ingredient Details
        ingredient_not_found: "Ingrédient introuvable",
        safety_label: "Sécurité",
        key_properties: "Propriétés Clés",
        recommended_dosage: "Dosage Recommandé",
        sources_references: "Sources et Références",
        ref_link: "Réf"
    }
};
